import { Box, Grid, Typography, TextField, MenuItem } from "@mui/material";
import styles from "../InternalTracker.module.css";
import RootComponents from "../../../components/common/RootComponents";
import { customTextColor } from "../../../utils/const";
import { IoIosArrowRoundForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import attachement from "../../../assets/images/attach.png"
import resume from "../../../assets/images/resume.png"
import profile_image from "../../../assets/images/ajit_image.jpeg";
import { useEffect, useState } from "react";
const fieldStyle = {
    width: "100%",
    "& .MuiInputBase-root": {
        paddingLeft: "30px", // Adjust padding to make space for the icon
    },
    "& .MuiInputLabel-root": {
        left: "35px",
        fontSize: "14px ", // Adjust label position to align with input text
    },
    "& .MuiInputBase-input": {
        paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
    },
    "& .MuiInputLabel-shrink": {
        left: "35px",
        fontSize: "14px  ", // Adjust label position when it shrinks
    },
    padding: "7px",
};




const InternalTrackerView = () => {

    const [selectedFileName, setSelectedFileName] = useState("");
    const [domain, setDomain] = useState([]);
    const navigate = useNavigate();

    const handleButtonClick = () => {
        document.getElementById("fileInput").click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFileName(file.name);
        }
    };
    const [showAttachments, setShowAttachments] = useState(false);

    const handleAddAttachmentClick = () => {
      setShowAttachments(!showAttachments);
    };
    return (
        // <RootComponents>
            <Box className={styles.add_structure}>

                <Box className={styles.resume_section}>
                    <Box style={{ color: customTextColor }}>
                        <Typography sx={{  fontSize: "25px !important" }}> <b>100% FREE</b></Typography>
                        <Typography

                        >
                            high priority email delivery with a minute
                        </Typography>
                        <Typography

                        >
                          Kevin Macklin Candidate selected for from your filter
                        </Typography>
                    </Box>
                </Box>
                <Typography
                    className={styles.add_heading}
                    style={{ color: customTextColor }}
                >
                   Subject or Headlines 
                </Typography>
                <Box className={styles.mandatory_description} >
              <Box sx={{ color: customTextColor, padding: '15px 15px 10px !important' }}>
                <Typography sx={{ padding: '0 5px 30px 0' }}>Job description</Typography>
                <textarea style={{ border: 'none' }} class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                <hr></hr>
                <Typography >Mandatory Skills</Typography>
                <textarea style={{ border: 'none' }} class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
              </Box>

            </Box>

            <div style={{ backgroundColor: '#fff', padding: '0 14px 14px ' }}>
              <span
                style={{ padding: '10px' }}
                className={styles.view_profile_link}
                onClick={handleAddAttachmentClick}
              >
                Add Attachment
              </span>
              {showAttachments && (
                <Grid container className={styles.download_section}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: '14px 0 0  4px' }}
                  >
                    <span style={{ color: customTextColor }}>
                      <Typography>Client Submission format:</Typography>
                      <Typography sx={{ cursor: 'pointer', lineHeight: '0' }}>
                        <img src={attachement} alt="attachment" style={{ width: '25px' }} />
                      </Typography>
                    </span>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: '13px 4px 5px 15px' }}
                  >
                    <span style={{ color: customTextColor }}>
                      <Typography>Reference Resume/profile</Typography>
                      <Typography sx={{ cursor: 'pointer', lineHeight: '0' }}>
                        <img src={resume} alt="resume" style={{ width: '25px' }} />
                      </Typography>
                    </span>
                  </Grid>
                </Grid>
              )}

             

              <Box className={styles.recruiter_profile}>
                <div >
                  <img src={profile_image} alt="" />
                  <span style={{ color: customTextColor }}>
                    <Typography style={{marginBottom:'12px '}}>
                      <b>  Thanks & Regrads  </b>
                    </Typography>
                    <Typography>
                      <b> Ajit Kumar Gahan</b>
                    </Typography>
                    <Typography>
                      UI Designer at Tek Inspiration
                    </Typography>
                    <Typography>
                      E-mail: Ajit@tekinspirations.com
                    </Typography>
                    <Typography sx={{ margin: "0 !important" }}>
                      Ph : 77012 54720
                    </Typography>
                  </span>
                </div>
              </Box>
            </div>
                <Box className={styles.consultant_btns}>
                    <button >
                    Send requirement
                  
                    </button>
                </Box>
            </Box>
        // </RootComponents >
    );
};

export default InternalTrackerView;
